<template>
    <div class="countdown-container">
        <button v-if="showButton" @click="cancelCountdown" :style="{ opacity: opacityValue }"
            class="countdown-button wd-lg-200 btn-primary btn">
            <template v-if="busy">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ (labelLoading) ? labelLoading : '' }}
            </template>

            <template v-else>
                Cancel ({{ countdown }})
            </template>
        </button>
    </div>
</template>

<script>
export default {
    data() {
        const countdown = this.initialSeconds
        return {
            countdown,
            interval: null,
            showButton: true,
        };
    },
    computed: {
        opacityValue() {
            return this.countdown / 5;
        },
    },
    mounted() {
        this.startCountdown();
    },
    watch: {
        showButton: function (value) {
            if (!value) {
                this.$emit('countdown-finished')
            }
        },
    },
    methods: {
        startCountdown() {
            this.interval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.showButton = false;
                    clearInterval(this.interval);
                }
            }, 1000);
        },
        cancelCountdown() {
            clearInterval(this.interval);
            this.countdown = this.initialSeconds

            this.$emit('cancel')
        },
    },
    props: ['initialSeconds', 'busy', 'labelLoading']
};
</script>

<style scoped>
.countdown-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.countdown-button {
    transition: opacity 1s ease-in-out;
}
</style>